import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

const QuickAccess = React.memo(({ lspInfo }) => {
  return (
    <div className="quick-access-container">
      <div className="quick-heading-align">
        <h4 className="quick-head">Quick Access</h4>
        <p className="quick-para">What information are you looking for?</p>
      </div>
      <div className="quick-cards-container">
        <div className="flex">
          <Link className="quick-access-card" to={`/lsp/${lspInfo?.id}/info`}>
            <div className="qa-icons-container">
              <span className="pi pi-building"></span>
            </div>
            <p>General Information</p>
          </Link>
          <Link
            className="quick-access-card"
            to={`/lsp/${lspInfo?.id}/addresses`}
          >
            <div className="qa-icons-container">
              <span className="pi pi-chart-pie"></span>
            </div>
            <p>Trading Address</p>
          </Link>
        </div>
        <div className="flex">
          <Link
            className="quick-access-card"
            to={`/lsp/${lspInfo?.id}/customer-portfolio`}
          >
            <div className="qa-icons-container">
              <span className="pi pi-file"></span>
            </div>
            <p>Customer Portfolio</p>
          </Link>
          <Link
            className="quick-access-card"
            to={`/lsp/${lspInfo?.id}/key-personnel`}
          >
            <div className="qa-icons-container">
              <span className="pi pi-users"></span>
            </div>
            <p>Key Personnel</p>
          </Link>
        </div>
      </div>
    </div>
  );
});
QuickAccess.displayName = "QuickAccess";

QuickAccess.propTypes = {
  lspInfo: PropTypes.object,
};

export default QuickAccess;
